import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol viewBox=\"0 0 14 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mail\">\n<path d=\"M7 8.40234C6.53516 8.40234 6.07031 8.23828 5.6875 7.9375L0 3.50781V9.6875C0 10.4258 0.574219 11 1.3125 11H12.6875C13.3984 11 14 10.4258 14 9.6875V3.50781L8.28516 7.9375C7.90234 8.23828 7.4375 8.40234 7 8.40234ZM0.4375 2.74219L6.23438 7.25391C6.67188 7.58203 7.30078 7.58203 7.73828 7.25391L13.5352 2.74219C13.8086 2.52344 14 2.19531 14 1.8125C14 1.10156 13.3984 0.5 12.6875 0.5H1.3125C0.574219 0.5 0 1.10156 0 1.8125C0 2.19531 0.164062 2.52344 0.4375 2.74219Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/mail.svg
// module id = ITPa
// module chunks = 13